import { Document } from 'document/document';
import { DocumentOutput } from 'document/model/document.output';

export abstract class DocumentConverterPort {
	public abstract documentAsEntity(output: DocumentOutput): Document;

	public abstract documentsAsEntities(outputs: DocumentOutput[]): Document[];
}
